import { v4 as uuid } from 'uuid';

export default [
  {
    id: uuid(),
    createdAt: '27/03/2019',
    description: 'תנובה היא חברה ליצור ושיווק מזון. החברה מחזיקה בנתח שוק משמעותי בתחום ייצור חלב לשתייה, מוצרי חלב ושיווקם. ב-1988 הוכרזה כמונופול בתחומים אלה. ',
    media: '/static/images/products/product_7.png',
    title: 'תנובה',
    totalDownloads: '594'
  },
  {
    id: uuid(),
    createdAt: '31/03/2019',
    description: 'אֹסֶם השקעות בע"מ היא קבוצת חברות מזון ישראלית גדולה, הנשלטת על ידי תאגיד המזון השווייצרי נסטלה, המחזיק ב-100% ממניותיה.',
    media: '/static/images/products/product_8.png',
    title: 'אסם',
    totalDownloads: '625'
  },
  {
    id: uuid(),
    createdAt: '03/04/2019',
    description: 'יוניליוור (Unilever) היא תאגיד רב-לאומי שנוצר מאיחוד שתי חברות, הולנדית ובריטית. החברה, השלישית בגודלה בעולם[דרוש מקור], מחזיקה בבעלותה רבים מן המותגים הבולטים בתחומי המזון, המשקאות, והטיפוח הביתי והאישי. החברה מעסיקה כ-180,000 עובדים ביותר מ-190 מדינות ברחבי העולם, ומייצרת ומפיצה למעלה מ-400 מותגים.',
    media: '/static/images/products/product_9.png',
    title: 'יוניליוור',
    totalDownloads: '857'
  },
  {
    id: uuid(),
    createdAt: '04/04/2019',
    description: 'דיפלומט אחזקות בע"מ היא חברה ציבורית ישראלית לייבוא והפצה של מוצרי מזון וטיפוח אישי. החברה מפיצה את מוצריהן של חברת פרוקטר אנד גמבל וחברות נוספות, ובנוסף לשוק הישראלי פועלת בשוק הייבוא בגאורגיה, בדרום אפריקה, בניו זילנד ובקפריסין',
    media: '/static/images/products/product_10.png',
    title: 'דיפלומט',
    totalDownloads: '406'
  },
  {
    id: uuid(),
    createdAt: '04/04/2019',
    description: 'טמפו משקאות בע"מ היא אחת מחברות המשקאות הגדולות והוותיקות בישראל. החברה מייצרת ומשווקת בירה, משקאות חריפים, משקאות מוגזים, משקאות קלים, מים מינרליים, משקאות אנרגיה ויין. לטמפו מגוון רחב של עשרות מותגים מקומיים ובינלאומיים מובילים',
    media: '/static/images/products/product_11.png',
    title: 'טמפו',
    totalDownloads: '835'
  },
  {
    id: uuid(),
    createdAt: '04/04/2019',
    description: 'החברה המרכזית לייצור משקאות קלים בע"מ, הידועה גם בשם קוקה-קולה ישראל, היא יצרנית ומשווקת וכן הזכיינית הבלעדית בישראל של חברת קוקה-קולה ובירות שונות כגון טובורג וקרלסברג, ומחזיקה במספר חברות מזון ומשקאות נוספות.',
    media: '/static/images/products/product_12.png',
    title: 'החברה המרכזית',
    totalDownloads: '835'
  }
];
